
import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-muted dark:bg-white/10 ocean:bg-blue-800/40 sunset:bg-orange-800/40 forest:bg-green-800/40 transition-colors duration-300",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
